import { useCallback, useEffect, useState } from 'react';
import { ConfirmDialog } from '@/ui_v3';
import { useAiBuilderChatCopy } from './useAiBuilderChatCopy';

/**
 * 패널 닫기 확인 흐름. 활성 AI 작업이 없으면 즉시 닫고,
 * 있으면 확인 다이얼로그를 거친다. 작업이 끝나거나 언마운트되면
 * 열려 있는 다이얼로그를 자동으로 정리한다.
 */
export const useAiBuilderCloseConfirmDialog = ({
  hasActiveAiWork,
  onClose
}: {
  hasActiveAiWork: boolean;
  onClose: () => void;
}) => {
  const copy = useAiBuilderChatCopy();
  const [closeConfirmOpen, setCloseConfirmOpen] = useState(false);
  useEffect(() => {
    if (hasActiveAiWork) return;
    setCloseConfirmOpen(false);
  }, [hasActiveAiWork]);
  const handleClosePanel = useCallback(() => {
    if (!hasActiveAiWork) {
      onClose();
      return;
    }
    setCloseConfirmOpen(true);
  }, [hasActiveAiWork, onClose]);
  const handleCancelClose = useCallback(() => {
    setCloseConfirmOpen(false);
  }, []);
  const handleConfirmClose = useCallback(() => {
    setCloseConfirmOpen(false);
    onClose();
  }, [onClose]);
  return {
    handleClosePanel,
    closeConfirmDialog: closeConfirmOpen ? <ConfirmDialog size="xs" header={{
      title: copy.closeConfirm.title
    }} body={copy.closeConfirm.description} cancelText={copy.closeConfirm.cancel} confirmText={copy.closeConfirm.close} confirmIntent="strong" shouldCloseOnDimClick={false} onClose={confirmed => {
      if (confirmed) {
        handleConfirmClose();
        return;
      }
      handleCancelClose();
    }} /> : null
  };
};